/* MDA PANIER : actions du tiroir et de la page panier.
   Principes (non négociables) :
   - le panier Shopify est la seule source de vérité : chaque action relit /cart.js avant d'agir et après avoir agi ;
   - la proposition affichée n'est jamais crue : avant toute mutation, le moteur Liquid est re-rendu sur le panier
     actuel et sa signature (data-sig) doit être identique, sinon rien n'est modifié ;
   - lignes visées par leur clé Shopify (line item key), jamais par leur position ;
   - une seule mutation à la fois (verrou de page + Web Locks entre onglets), contrôles désactivés pendant l'action ;
   - passage à une routine : ajout vérifié, retrait exact d'une unité par soin, contrôle final ; toute anomalie
     déclenche un retour à l'état initial vérifié. Mieux vaut une action qui échoue proprement qu'un panier partiel ;
   - aucun identifiant produit dans ce fichier : tout vient du rendu Liquid (métachamps, metaobjects).
   Mesure : window.mdaTrack (préfixe mda_) si présent, sinon le même envoi (dataLayer + Shopify.analytics.publish). */
(function () {
  'use strict';
  if (window.__mdaCart) return; window.__mdaCart = 1;
  var d = document, w = window;
  var ROOT = w.Shopify && Shopify.routes && Shopify.routes.root || '/';
  var MSG = {
    routine: 'La routine n’a pas pu être ajoutée. Votre panier n’a pas été modifié.',
    routineDirty: 'La routine n’a pas pu être ajoutée. Vérifiez votre panier avant de passer commande.',
    add: 'Le soin n’a pas pu être ajouté. Votre panier n’a pas été modifié.',
    stale: 'Votre panier a changé entre-temps. La suggestion a été mise à jour.',
    unavailable: 'Ce soin n’est plus disponible pour le moment. La suggestion a été mise à jour.',
    unavailableRoutine: 'Cette routine n’est plus disponible pour le moment. Votre panier n’a pas été modifié.',
    line: 'La quantité n’a pas pu être modifiée. Réessayez.',
    lineGone: 'Ce soin n’est plus dans votre panier. Le panier a été mis à jour.',
    network: 'Connexion interrompue. Votre panier n’a pas été modifié.',
    networkLine: 'Connexion interrompue. Réessayez.',
    codeKo: 'Ce code ne s’applique pas à ce panier.',
    codeOk: 'Code appliqué.',
    codeEmpty: 'Saisissez un code.',
    added: 'Ajouté à votre panier.',
    shipFree: 'Livraison offerte.',
    shipLater: 'Livraison calculée à l’étape suivante.',
    shipFreeShort: 'Offerte',
    shipLaterShort: 'Calculée à l’étape suivante'
  };

  /* ---------- Mesure */
  function track(name, data) {
    data = data || {};
    try {
      if (w.mdaTrack && !w.__mdaHome) { w.mdaTrack(name, data); return; }
      var p = Object.assign({ page_type: pageType(), device_type: (w.innerWidth || 0) < 768 ? 'mobile' : 'desktop' }, data);
      (w.dataLayer = w.dataLayer || []).push(Object.assign({ event: 'mda_' + name }, p));
      if (w.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mda_' + name, p);
    } catch (e) {}
  }
  function pageType() {
    var r = d.documentElement.getAttribute('data-mda-page');
    if (r) return r;
    try { return (w.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType) || 'other'; } catch (e) { return 'other'; }
  }
  function common(root, cart) {
    var o = { surface: root ? root.getAttribute('data-surface') : 'drawer', market: root ? (root.getAttribute('data-market') || '') : '', country: root ? (root.getAttribute('data-country') || '') : '', page_type: pageType(), device_type: (w.innerWidth || 0) < 768 ? 'mobile' : 'desktop' };
    if (cart) { o.cart_value = cartBase(cart) / 100; o.items_count = cart.item_count; }
    else if (root) { var t = root.querySelector('[data-mda-total]'); o.cart_value = t ? (+t.getAttribute('data-cents') || 0) / 100 : 0; o.items_count = +root.getAttribute('data-count') || 0; }
    return o;
  }
  function cartBase(cart) {
    var b = cart.items_subtotal_price || 0;
    (cart.cart_level_discount_applications || []).forEach(function (x) { b -= x.total_allocated_amount || 0; });
    return b;
  }

  /* ---------- Réseau : délai maximal, erreurs Shopify (422, 400, 5xx) normalisées */
  function req(url, body, method) {
    var ctl = w.AbortController ? new AbortController() : null;
    var to = setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
    var opt = { method: method || (body ? 'POST' : 'GET'), credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    if (ctl) opt.signal = ctl.signal;
    return fetch(url, opt).then(function (r) {
      clearTimeout(to);
      return r.text().then(function (t) {
        var j = null; try { j = t ? JSON.parse(t) : null; } catch (e) {}
        if (!r.ok || (j && j.status && typeof j.status === 'number' && j.status >= 400)) {
          var err = new Error((j && (j.description || j.message)) || ('HTTP ' + r.status)); err.status = r.status; err.body = j; throw err;
        }
        return j;
      });
    }, function (e) { clearTimeout(to); var err = new Error('network'); err.status = 0; throw err; });
  }
  var getCart = function () { return req(ROOT + 'cart.js?_=' + Date.now()); };
  var change = function (key, qty) { return req(ROOT + 'cart/change.js', { id: key, quantity: qty }); };
  var addItems = function (items) { return req(ROOT + 'cart/add.js', { items: items }); };
  var update = function (body) { return req(ROOT + 'cart/update.js', body); };

  /* ---------- Rendu : sections re-rendues par Shopify à partir du panier réel */
  function sectionsWanted() {
    var s = ['cart-drawer', 'cart-bubble'];
    if (d.getElementById('MdaCart')) s.push('main-cart');
    return s;
  }
  /* Section Rendering API : pas d'en-tête « Accept: application/json » (sur /cart, Shopify renverrait le panier JSON) */
  function fetchSections() {
    var want = sectionsWanted();
    var u = w.location.pathname + '?sections=' + want.join(',') + '&_=' + Date.now();
    return fetch(u, { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
      if (!r.ok) { var e = new Error('HTTP ' + r.status); e.status = r.status; throw e; }
      return r.json();
    }, function () { var e = new Error('network'); e.status = 0; throw e; }).then(function (j) {
      if (!j || typeof j[want[0]] !== 'string') { var e = new Error('sections'); e.status = 0; throw e; }
      return j;
    });
  }
  function parse(html, sel) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(sel);
  }
  function apply(sections, focusHint) {
    if (!sections) return;
    var drawer = d.getElementById('Cart-Drawer');
    var scroll = drawer && drawer.querySelector('[data-mda-scroll]');
    var st = scroll ? scroll.scrollTop : 0;
    if (drawer && sections['cart-drawer']) {
      var nd = parse(sections['cart-drawer'], '.cart-drawer');
      if (nd) drawer.innerHTML = nd.innerHTML;
      var ns = drawer.querySelector('[data-mda-scroll]'); if (ns) ns.scrollTop = st;
    }
    var bubble = d.getElementById('cart-drawer-toggle');
    if (bubble && sections['cart-bubble']) {
      var c = bubble.querySelector('.thb-item-count'), nc = parse(sections['cart-bubble'], '.thb-item-count');
      if (c && nc) c.innerHTML = nc.innerHTML;
    }
    var page = d.getElementById('MdaCart');
    if (page && sections['main-cart']) {
      var np = parse(sections['main-cart'], '#MdaCart');
      if (np) {
        var openCode = page.querySelector('[data-mda-code]'); openCode = openCode && openCode.open;
        /* boutons express (Shop Pay, PayPal) et widget Scalapay : initialisés une seule fois par leurs scripts,
           on conserve les nœuds existants au lieu de les recréer vides */
        var oldX = page.querySelector('.mda-cp__express-btns');
        var keep = page.querySelectorAll('.mda-cp__cta-wrap > :not(.mda-cp__cta)');
        page.innerHTML = np.innerHTML;
        var newX = page.querySelector('.mda-cp__express-btns');
        if (oldX && newX) newX.parentNode.replaceChild(oldX, newX);
        var wrap = page.querySelector('.mda-cp__cta-wrap');
        if (wrap) keep.forEach(function (n) { wrap.appendChild(n); });
        var nc2 = page.querySelector('[data-mda-code]'); if (nc2 && openCode) nc2.open = true;
        try { d.dispatchEvent(new CustomEvent('mda:cart-rendered')); } catch (e) {}
      }
    }
    restoreFocus(focusHint);
    afterRender();
  }
  function refresh(focusHint) { return fetchSections().then(function (s) { apply(s, focusHint); return s; }); }
  function restoreFocus(h) {
    if (!h) return;
    var el = null;
    if (h.key) {
      var line = d.querySelector((h.surface === 'cart_page' ? '#MdaCart ' : '#Cart-Drawer ') + '[data-mda-line][data-key="' + cssEsc(h.key) + '"]');
      if (line && h.to != null) el = line.querySelector('[data-mda-action="qty"][data-to="' + (h.dir > 0 ? (+h.to + 1) : (+h.to - 1)) + '"]') || line.querySelector('[data-mda-action="qty"]:not([disabled])');
    }
    if (!el && h.fallback) el = d.querySelector(h.fallback);
    if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) {} }
  }
  function cssEsc(s) { return (w.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }

  /* ---------- Verrou : une mutation à la fois (page + onglets) */
  var chain = Promise.resolve(), busy = false;
  function locked(fn) {
    if (busy) return Promise.resolve(false);
    busy = true; setBusy(true);
    var run = function () { return Promise.resolve().then(fn); };
    var p = (w.navigator && navigator.locks && navigator.locks.request) ? navigator.locks.request('mda-cart', run) : run();
    chain = p.then(function () {}, function () {});
    return p.catch(function (e) {
      try { console.error('[mda-cart]', e); } catch (x) {}
      return refresh().catch(function () {});
    }).finally(function () { busy = false; setBusy(false); broadcast(); });
  }
  function setBusy(on) {
    d.querySelectorAll('[data-mda-cart-root]').forEach(function (r) {
      if (on) r.setAttribute('aria-busy', 'true'); else r.removeAttribute('aria-busy');
      r.querySelectorAll('[data-mda-action], [data-mda-checkout-form] button').forEach(function (b) {
        if (on) { if (!b.disabled) { b.disabled = true; b.setAttribute('data-mda-lock', ''); } }
        else if (b.hasAttribute('data-mda-lock')) { b.disabled = false; b.removeAttribute('data-mda-lock'); }
      });
    });
  }
  var bc = null; try { bc = new BroadcastChannel('mda-cart'); bc.onmessage = function () { if (!busy) refresh(); }; } catch (e) {}
  function broadcast() { try { bc && bc.postMessage(Date.now()); } catch (e) {} }

  /* ---------- Outils panier */
  function lineByKey(cart, key) { for (var i = 0; i < cart.items.length; i++) if (cart.items[i].key === key) return cart.items[i]; return null; }
  function isStandalone(it) { return !it.item_components || !it.item_components.length; }
  function propsSig(p) { var o = {}; Object.keys(p || {}).sort().forEach(function (k) { o[k] = p[k]; }); return JSON.stringify(o); }
  function snapshot(cart) { var m = {}; cart.items.forEach(function (it) { var k = it.variant_id + '|' + propsSig(it.properties); m[k] = (m[k] || 0) + it.quantity; }); return m; }
  function sameSnap(a, b) { var ka = Object.keys(a), kb = Object.keys(b); if (ka.length !== kb.length) return false; return ka.every(function (k) { return a[k] === b[k]; }); }
  function qtyOf(cart, vid, src) { var q = 0; cart.items.forEach(function (it) { if (it.variant_id === vid && (src === undefined || (it.properties && it.properties._mda_src) === src)) q += it.quantity; }); return q; }
  function lineWithSrc(cart, vid, src) { for (var i = 0; i < cart.items.length; i++) { var it = cart.items[i]; if (it.variant_id === vid && it.properties && it.properties._mda_src === src) return it; } return null; }
  /* composant à retirer : ligne autonome du bon variant, de préférence sans propriété, sinon la plus fournie */
  function pickComponentLine(cart, vid, need) {
    var c = cart.items.filter(function (it) { return it.variant_id === vid && isStandalone(it); });
    c.sort(function (a, b) { var pa = Object.keys(a.properties || {}).length, pb = Object.keys(b.properties || {}).length; return pa - pb || b.quantity - a.quantity; });
    for (var i = 0; i < c.length; i++) if (c[i].quantity >= need) return c[i];
    return null;
  }
  function parseRemove(s) { return (s || '').split(',').filter(Boolean).map(function (x) { var p = x.split(':'); return { vid: +p[0], qty: +p[1] || 1 }; }); }
  function variantAvailable(handle, vid) {
    return req(ROOT + 'products/' + encodeURIComponent(handle) + '.js?_=' + Date.now()).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.id === vid; })[0];
      return !!(v && v.available);
    });
  }
  function freshModule(sections, surface, rule) {
    var html = surface === 'cart_page' ? sections['main-cart'] : sections['cart-drawer'];
    var sel = (surface === 'cart_page' ? '#MdaCart' : '.cart-drawer');
    var root = parse(html, sel);
    return root ? root.querySelector('[data-mda-reco][data-rule="' + cssEsc(rule) + '"]') : null;
  }
  function say(root, text) { var l = root && root.querySelector('[data-mda-live]'); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = text; }, 30); } }
  function moduleMsg(surface, text) {
    var sel = surface === 'cart_page' ? '#MdaCart [data-mda-reco-msg], #MdaCart [data-mda-live]' : '#Cart-Drawer [data-mda-reco-msg], #Cart-Drawer [data-mda-live]';
    var els = d.querySelectorAll(sel), shown = false;
    els.forEach(function (el) { if (!shown && el.hasAttribute('data-mda-reco-msg')) { el.textContent = text; el.hidden = false; shown = true; } });
    if (!shown) els.forEach(function (el) { if (el.hasAttribute('data-mda-live')) { el.textContent = text; el.classList.add('is-msg'); } });
  }

  /* ---------- Actions ligne : quantité, retrait (clé de ligne, relecture avant et après) */
  function onQty(btn, root, surface) {
    var li = btn.closest('[data-mda-line]'); if (!li) return;
    var key = li.getAttribute('data-key'), to = Math.max(0, +btn.getAttribute('data-to') || 0), from = +li.getAttribute('data-qty');
    var remove = btn.getAttribute('data-mda-action') === 'remove';
    if (remove) to = 0;
    li.classList.add('is-loading');
    locked(function () {
      return getCart().then(function (cart) {
        var line = lineByKey(cart, key);
        if (!line) { return refresh().then(function () { say(currentRoot(surface), MSG.lineGone); }); }
        from = line.quantity;
        return change(key, to).then(function (res) {
          var after = lineByKey(res, key), got = after ? after.quantity : 0;
          var info = Object.assign(common(root, res), { product: li.getAttribute('data-handle'), variant: +li.getAttribute('data-vid'), from: from, to: got, src: li.getAttribute('data-src') || '' });
          if (to === 0) track('cart_remove', Object.assign(info, { value: (+li.getAttribute('data-line-price') || 0) / 100 }));
          else track('cart_quantity_change', info);
          var capped = to > 0 && got < to;
          return refresh({ key: key, to: got, dir: to > from ? 1 : -1, surface: surface, fallback: surface === 'cart_page' ? '#MdaCart h1' : '#Cart-Drawer .mda-cd__close button' }).then(function () {
            if (capped) lineError(surface, key, 'Quantité maximale disponible : ' + got + '.');
            thresholdCheck(res, 'quantity');
          });
        });
      }).catch(function (e) {
        return refresh().then(function () { lineError(surface, key, e.status === 422 && e.message && e.message.length < 160 ? e.message : (e.status === 0 ? MSG.networkLine : MSG.line)); }, function () { li.classList.remove('is-loading'); lineError(surface, key, MSG.networkLine); });
      });
    });
  }
  function lineError(surface, key, text) {
    var li = d.querySelector((surface === 'cart_page' ? '#MdaCart' : '#Cart-Drawer') + ' [data-mda-line][data-key="' + cssEsc(key) + '"]');
    var p = li && li.querySelector('[data-mda-line-err]');
    if (p) { p.textContent = text; p.hidden = false; } else say(currentRoot(surface), text);
  }
  function currentRoot(surface) { return d.querySelector(surface === 'cart_page' ? '#MdaCart [data-mda-cart-root]' : '#Cart-Drawer [data-mda-cart-root]'); }

  /* ---------- Proposition dynamique */
  function readModule(m) {
    return {
      rule: m.getAttribute('data-rule'), kind: m.getAttribute('data-kind'), sig: m.getAttribute('data-sig'),
      add: +m.getAttribute('data-add'), addHandle: m.getAttribute('data-add-handle'), remove: parseRemove(m.getAttribute('data-remove')),
      src: m.getAttribute('data-src'), product: m.getAttribute('data-product'), price: +m.getAttribute('data-price') || 0,
      incr: +m.getAttribute('data-incr') || 0, save: +m.getAttribute('data-save') || 0, orig: +m.getAttribute('data-orig') || 0, cross: m.getAttribute('data-cross') === '1'
    };
  }
  function recoFields(r) {
    var o = { rule_id: r.rule, rec_type: r.kind, rec_product: r.product, price: r.price / 100, incremental_value: r.incr / 100, original_cart_value: r.orig / 100, crosses_threshold: r.cross };
    if (r.kind === 'bundle_upgrade' || r.kind === 'complete_routine') { o.bundle = r.product; o.saving = r.save / 100; }
    return o;
  }
  function onReco(btn, root, surface) {
    var m = btn.closest('[data-mda-reco]'); if (!m) return;
    var r = readModule(m);
    var isSwap = r.kind === 'bundle_upgrade' || r.kind === 'complete_routine';
    var base = Object.assign(common(root), recoFields(r));
    track(r.kind === 'bundle_upgrade' ? 'cart_bundle_upgrade_click' : 'cart_recommendation_add', base);
    m.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    locked(function () {
      /* 1-2. revalider la règle sur un rendu frais du panier réel */
      return fetchSections().then(function (sections) {
        var fm = freshModule(sections, surface, r.rule);
        if (!fm || fm.getAttribute('data-sig') !== r.sig) {
          apply(sections); m.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); moduleMsg(surface, MSG.stale);
          track('cart_recommendation_stale', base);
          return;
        }
        return (isSwap ? swap(r) : addOne(r)).then(function (out) {
          if (out.ok) {
            var fields = Object.assign(common(root, out.cart), recoFields(r), { new_cart_value: cartBase(out.cart) / 100 });
            track(r.kind === 'bundle_upgrade' ? 'cart_bundle_upgrade_success' : 'cart_recommendation_success', fields);
            return refresh({ fallback: surface === 'cart_page' ? '#MdaCart h1' : '#Cart-Drawer .mda-cd__cta' }).then(function () {
              say(currentRoot(surface), isSwap ? 'Routine ajoutée à votre panier.' : MSG.added);
              thresholdCheck(out.cart, isSwap ? 'bundle' : 'reco', out.before);
            });
          }
          track(r.kind === 'bundle_upgrade' ? 'cart_bundle_upgrade_error' : 'cart_recommendation_error', Object.assign(base, { stage: out.stage, clean: out.clean !== false, code: out.code || 0 }));
          return refresh().then(function () { moduleMsg(surface, out.msg); });
        });
      }).catch(function (e) {
        track('cart_recommendation_error', Object.assign(base, { stage: 'revalidate', code: e.status || 0 }));
        return refresh().then(function () { moduleMsg(surface, e.status === 0 ? MSG.network : (isSwap ? MSG.routine : MSG.add)); }, function () { m.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
      });
    });
  }

  /* Ajout simple (complément, accessoire, grand format) : idempotent, vérifié */
  function addOne(r) {
    var before;
    return getCart().then(function (cart) {
      before = cart;
      if (qtyOf(cart, r.add) > 0) return { ok: false, stage: 'precheck_present', msg: MSG.stale, clean: true };
      return variantAvailable(r.addHandle, r.add).then(function (av) {
        if (!av) return { ok: false, stage: 'unavailable', msg: MSG.unavailable, clean: true };
        return addItems([{ id: r.add, quantity: 1, properties: { _mda_src: r.src } }]).then(function () { return getCart(); }).then(function (after) {
          var n = qtyOf(after, r.add, r.src);
          if (n === 1) return { ok: true, cart: after, before: before };
          if (n > 1) { var l = lineWithSrc(after, r.add, r.src); return change(l.key, 1).then(getCart).then(function (c2) { return qtyOf(c2, r.add, r.src) === 1 ? { ok: true, cart: c2, before: before } : { ok: false, stage: 'dedupe', msg: MSG.routineDirty, clean: false }; }); }
          return { ok: false, stage: 'verify_add', msg: MSG.add, clean: sameSnap(snapshot(before), snapshot(after)) };
        }, function (e) {
          return getCart().then(function (after) { return { ok: false, stage: 'add', code: e.status, msg: e.status === 0 ? MSG.network : MSG.add, clean: sameSnap(snapshot(before), snapshot(after)) }; });
        });
      });
    });
  }

  /* Passage à la routine : séquence verrouillée, retour arrière vérifié */
  function swap(r) {
    var before, snapBefore, bundleBefore, removed = [], addedKey = null;
    function fail(stage, e) {
      return rollback().then(function (clean) {
        return { ok: false, stage: stage, code: e && e.status || 0, clean: clean, msg: clean ? (e && e.status === 0 ? MSG.network : MSG.routine) : MSG.routineDirty };
      });
    }
    function rollback() {
      var steps = Promise.resolve();
      removed.slice().reverse().forEach(function (x) {
        steps = steps.then(function () { return addItems([{ id: x.vid, quantity: x.qty, properties: x.props || {} }]).catch(function () {}); });
      });
      return steps.then(getCart).then(function (c) {
        var l = lineWithSrc(c, r.add, r.src);
        var extra = qtyOf(c, r.add, r.src) - bundleBefore;
        if (l && extra > 0) return change(l.key, Math.max(0, l.quantity - extra)).catch(function () {}).then(getCart);
        return c;
      }).then(function (c) { return sameSnap(snapBefore, snapshot(c)); }, function () { return false; });
    }
    /* 3. relire le panier, vérifier les soins à remplacer ; 4. vérifier la routine */
    return getCart().then(function (cart) {
      before = cart; snapBefore = snapshot(cart); bundleBefore = qtyOf(cart, r.add, r.src);
      var plan = [];
      for (var i = 0; i < r.remove.length; i++) {
        var need = r.remove[i], line = pickComponentLine(cart, need.vid, need.qty);
        if (!line) return { ok: false, stage: 'precheck_components', msg: MSG.stale, clean: true };
        plan.push({ key: line.key, vid: need.vid, qty: need.qty, had: line.quantity, props: line.properties || {} });
      }
      if (!plan.length) return { ok: false, stage: 'precheck_empty', msg: MSG.stale, clean: true };
      return variantAvailable(r.addHandle, r.add).then(function (av) {
        if (!av) return { ok: false, stage: 'unavailable', msg: MSG.unavailableRoutine, clean: true };
        /* 5. ajouter la routine ; 6. confirmer */
        return addItems([{ id: r.add, quantity: 1, properties: { _mda_src: r.src } }]).then(getCart, function (e) {
          return getCart().then(function (c) { var err = new Error('add'); err.status = e.status; err.cart = c; throw err; });
        }).then(function (c) {
          var n = qtyOf(c, r.add, r.src) - bundleBefore;
          if (n < 1) throw Object.assign(new Error('verify_add'), { status: 0, stage: 'verify_add' });
          var l = lineWithSrc(c, r.add, r.src); addedKey = l && l.key;
          if (n > 1 && l) return change(l.key, l.quantity - (n - 1)).then(getCart);
          return c;
        }).then(function () {
          /* 7. retirer exactement les unités prévues, une ligne à la fois, par clé */
          var s = Promise.resolve();
          plan.forEach(function (p) {
            s = s.then(getCart).then(function (c) {
              var line = lineByKey(c, p.key);
              if (!line || line.quantity < p.qty) throw Object.assign(new Error('component_changed'), { stage: 'component_changed', status: 0 });
              return change(p.key, line.quantity - p.qty).then(function (res) {
                removed.push({ vid: p.vid, qty: p.qty, props: p.props });
                var after = lineByKey(res, p.key), q = after ? after.quantity : 0;
                if (q !== line.quantity - p.qty) throw Object.assign(new Error('remove_mismatch'), { stage: 'remove_mismatch', status: 0 });
              });
            });
          });
          return s;
        }).then(getCart).then(function (fin) {
          /* 8-9. contrôle final : +1 routine, −1 unité par soin, rien d'autre n'a bougé */
          var expect = Object.assign({}, snapBefore);
          var bk = r.add + '|' + propsSig({ _mda_src: r.src }); expect[bk] = (expect[bk] || 0) + 1;
          plan.forEach(function (p) { var k = p.vid + '|' + propsSig(p.props); expect[k] = (expect[k] || 0) - p.qty; if (expect[k] === 0) delete expect[k]; });
          if (!sameSnap(expect, snapshot(fin))) throw Object.assign(new Error('final_check'), { stage: 'final_check', status: 0 });
          return { ok: true, cart: fin, before: before };
        }).catch(function (e) { return fail(e.stage || (removed.length ? 'remove' : 'add'), e); });
      });
    });
  }

  function onDismiss(btn, root, surface) {
    var m = btn.closest('[data-mda-reco]'); if (!m) return;
    var r = readModule(m);
    locked(function () {
      return getCart().then(function (cart) {
        var cur = (cart.attributes && cart.attributes._mda_dismiss) || '';
        var list = cur.split(',').filter(Boolean); if (list.indexOf(r.rule) < 0) list.push(r.rule);
        return update({ attributes: { _mda_dismiss: list.join(',') } });
      }).then(function () {
        track(r.kind === 'bundle_upgrade' ? 'cart_bundle_upgrade_dismiss' : 'cart_recommendation_dismiss', Object.assign(common(root), recoFields(r)));
        return refresh();
      }).catch(function () { return refresh(); });
    });
  }

  /* ---------- Code avantage (page panier) : /cart/update.js { discount } ; code non applicable retiré, jamais laissé en suspens */
  function currentCodes(cart) { return (cart.discount_codes || []).map(function (c) { return c.code; }); }
  function onCode(form, root) {
    var inp = form.querySelector('input'), code = (inp.value || '').trim();
    var msg = function (t, ok) { var p = d.querySelector('#MdaCart [data-mda-code-msg]'); if (p) { p.textContent = t; p.classList.toggle('is-ok', !!ok); } };
    if (!code) { msg(MSG.codeEmpty); inp.focus(); return; }
    locked(function () {
      var prev;
      return getCart().then(function (cart) {
        prev = currentCodes(cart);
        if (prev.map(function (c) { return c.toUpperCase(); }).indexOf(code.toUpperCase()) >= 0) return { same: true };
        return update({ discount: prev.concat([code]).join(',') });
      }).then(function (res) {
        if (res && res.same) return refresh().then(function () { msg(MSG.codeOk, true); });
        var mine = (res.discount_codes || []).filter(function (c) { return c.code.toUpperCase() === code.toUpperCase(); })[0];
        if (!mine || !mine.applicable) {
          track('cart_discount_error', Object.assign(common(root, res), { reason: mine ? 'not_applicable' : 'unknown' }));
          return update({ discount: prev.join(',') }).then(function () { return refresh(); }).then(function () { msg(MSG.codeKo); var i2 = d.getElementById('MdaCartCode'); if (i2) { i2.value = code; i2.focus(); } });
        }
        track('cart_discount_apply', Object.assign(common(root, res), { code_applied: true }));
        return refresh().then(function () { msg(MSG.codeOk, true); thresholdCheck(res, 'code'); });
      }).catch(function (e) { return refresh().then(function () { msg(e.status === 0 ? MSG.network : MSG.codeKo); }); });
    });
  }
  function onCodeRemove(btn, root) {
    var code = btn.getAttribute('data-code');
    locked(function () {
      return getCart().then(function (cart) {
        var rest = currentCodes(cart).filter(function (c) { return c.toUpperCase() !== String(code).toUpperCase(); });
        return update({ discount: rest.join(',') });
      }).then(function (res) { track('cart_discount_remove', common(root, res)); return refresh({ fallback: '#MdaCart [data-mda-code] summary' }); }).catch(function () { return refresh(); });
    });
  }
  var noteT = null;
  function onNote(ta) {
    clearTimeout(noteT);
    noteT = setTimeout(function () {
      var v = ta.value, p = d.querySelector('#MdaCart [data-mda-note-msg]');
      update({ note: v }).then(function () { if (p) p.textContent = 'Remarque enregistrée.'; }, function () { if (p) p.textContent = 'La remarque n’a pas pu être enregistrée.'; });
    }, 600);
  }

  /* ---------- Livraison offerte : vue et franchissement du seuil */
  var shipSeen = {}, lastReached = null;
  function shipState() {
    var el = d.querySelector('#Cart-Drawer [data-mda-ship]') || d.querySelector('#MdaCart [data-mda-ship]');
    if (!el) return null;
    return { el: el, reached: el.getAttribute('data-state') === 'reached', thr: +el.getAttribute('data-thr') || 0, base: +el.getAttribute('data-base') || 0, rem: +el.getAttribute('data-remaining') || 0 };
  }
  function thresholdCheck(cart, via) {
    var s = shipState(); if (!s) return;
    if (s.reached && lastReached === false) track('cart_shipping_threshold_reached', Object.assign(common(null, cart), { threshold: s.thr / 100, via: via }));
    lastReached = s.reached;
  }
  function renderJsShipping() {
    d.querySelectorAll('[data-mda-ship][data-js]').forEach(function (el) {
      /* Seuil en devise locale (réglage « GB=105 GBP ») : direct. Sinon conversion au taux affiché par Shopify,
         qui inclut les frais de change : le seuil obtenu est légèrement au-dessus de celui du checkout (≈ 2 %),
         donc « débloquée » n'est jamais affiché si la livraison est payante. */
      var rate = (w.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
      var loc = el.getAttribute('data-thr-local');
      var thr = loc ? +loc : Math.round((+el.getAttribute('data-thr-shop') || 0) * rate), base = +el.getAttribute('data-base') || 0;
      if (!thr) return;
      var cur = (w.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var fmt = function (c) { try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + cur; } };
      var t = el.querySelector('[data-mda-ship-text]'), bar = el.querySelector('.mda-cs__bar span');
      var rem = thr - base;
      el.setAttribute('data-thr', thr); el.setAttribute('data-base', base);
      if (rem > 0) { el.setAttribute('data-state', 'remaining'); el.setAttribute('data-remaining', rem); t.innerHTML = 'Il vous manque <strong>' + fmt(rem) + '</strong> pour profiter de la livraison offerte.'; bar.style.width = Math.floor(base * 100 / thr) + '%'; }
      else { el.setAttribute('data-state', 'reached'); el.classList.add('is-reached'); t.textContent = 'Livraison offerte débloquée.'; bar.style.width = '100%'; }
      el.hidden = false;
      var root = el.closest('[data-mda-cart-root]'), sum = root && root.querySelector('[data-mda-ship-sum]');
      if (sum) sum.textContent = rem > 0 ? (sum.closest('.mda-cd__tax') ? MSG.shipLater : MSG.shipLaterShort) : (sum.closest('.mda-cd__tax') ? MSG.shipFree : MSG.shipFreeShort);
    });
  }

  /* ---------- Vues (une fois par état, quand le module est réellement visible) */
  var seen = {};
  function observeViews() {
    var drawer = d.getElementById('Cart-Drawer');
    var drawerOpen = drawer && drawer.classList.contains('active');
    d.querySelectorAll('[data-mda-reco]').forEach(function (m) {
      var inDrawer = !!m.closest('#Cart-Drawer');
      if (inDrawer && !drawerOpen) return;
      var r = readModule(m), k = (inDrawer ? 'd' : 'p') + r.sig;
      if (seen[k]) return;
      var fire = function () {
        if (seen[k]) return; seen[k] = 1;
        var root = m.closest('[data-mda-cart-root]');
        track(r.kind === 'bundle_upgrade' ? 'cart_bundle_upgrade_view' : 'cart_recommendation_view', Object.assign(common(root), recoFields(r)));
      };
      if (!('IntersectionObserver' in w)) { fire(); return; }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.5) { fire(); io.disconnect(); } }); }, { threshold: [0.5] });
      io.observe(m);
    });
    var s = shipState();
    if (s && (!s.el.closest('#Cart-Drawer') || drawerOpen)) {
      var sk = (s.el.closest('#Cart-Drawer') ? 'd' : 'p') + s.reached + s.thr;
      if (!shipSeen[sk]) { shipSeen[sk] = 1; track('cart_shipping_threshold_view', Object.assign(common(s.el.closest('[data-mda-cart-root]')), { threshold: s.thr / 100, remaining: Math.max(0, s.rem) / 100, reached: s.reached })); }
      if (lastReached === null) lastReached = s.reached;
    }
  }
  function afterRender() { renderJsShipping(); observeViews(); }

  /* ---------- Délégation d'événements (le contenu est re-rendu : aucun écouteur par élément) */
  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mda-action]');
    if (!b) return;
    var root = b.closest('[data-mda-cart-root]'); if (!root) return;
    var act = b.getAttribute('data-mda-action'), surface = root.getAttribute('data-surface');
    if (act === 'code') return; /* géré par submit */
    e.preventDefault();
    if (busy || b.disabled) return;
    if (act === 'qty' || act === 'remove') onQty(b, root, surface);
    else if (act === 'reco') onReco(b, root, surface);
    else if (act === 'dismiss') onDismiss(b, root, surface);
    else if (act === 'code-remove') onCodeRemove(b, root);
  });
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('[data-mda-code-form]')) { e.preventDefault(); if (!busy) onCode(f, f.closest('[data-mda-cart-root]')); return; }
    if (f.matches && f.matches('[data-mda-checkout-form]')) {
      if (busy) { e.preventDefault(); return; }
      var root = f.closest('[data-mda-cart-root]'), s = shipState();
      var lines = root ? root.querySelectorAll('[data-mda-line]') : [];
      var hasBundle = false, hasReco = false;
      lines.forEach(function (l) { if (l.hasAttribute('data-bundle')) hasBundle = true; if ((l.getAttribute('data-src') || '').indexOf('cart_') === 0) hasReco = true; });
      track('cart_checkout_click', Object.assign(common(root), { has_bundle: hasBundle, has_reco_item: hasReco, threshold_reached: s ? s.reached : null }));
    }
  });
  d.addEventListener('input', function (e) { if (e.target.matches && e.target.matches('[data-mda-note]')) onNote(e.target); });

  /* Ouverture du tiroir : origine (ajout produit ou icône), confirmation d'ajout, vues */
  var lastAdd = 0, lastIcon = 0;
  /* ajout depuis une fiche produit (code du thème) : les autres onglets se mettent à jour aussitôt */
  d.addEventListener('cart:item-added', function () { lastAdd = Date.now(); broadcast(); });
  d.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#cart-drawer-toggle')) lastIcon = Date.now(); }, true);
  d.addEventListener('cart-drawer:open', function () {
    /* le thème ouvre le tiroir juste avant d'annoncer l'ajout : on attend l'événement d'ajout */
    setTimeout(function () {
      var now = Date.now(), trig = now - lastAdd < 4000 ? 'add' : (now - lastIcon < 1500 ? 'icon' : 'other');
      var root = d.querySelector('#Cart-Drawer [data-mda-cart-root]');
      if (trig === 'add') say(root, MSG.added);
      track('cart_drawer_open', Object.assign(common(root), { trigger: trig }));
    }, 80);
    setTimeout(observeViews, 320);
  });
  /* contenu du tiroir remplacé par un ajout produit (code du thème ou mda-core) : relancer rendu JS et vues */
  function watchDrawer() {
    var drawer = d.getElementById('Cart-Drawer'); if (!drawer || !w.MutationObserver) return;
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(afterRender, 60); }).observe(drawer, { childList: true });
  }
  /* Retour arrière (cache de page) ou onglet revenu au premier plan : le panier a pu changer ailleurs */
  w.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; setBusy(false); refresh(); } });
  var hiddenAt = d.hidden ? Date.now() : 0; /* onglet ouvert en arrière-plan : relu à sa première apparition */
  d.addEventListener('visibilitychange', function () { if (d.hidden) hiddenAt = Date.now(); else if (hiddenAt && Date.now() - hiddenAt > 2000 && !busy) refresh(); });

  function init() { watchDrawer(); afterRender(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  w.mdaCart = { refresh: refresh, _state: function () { return { busy: busy }; } };
})();
